import React, { useCallback, useRef, useState } from "react";
import Tooltip from "@mui/material/Tooltip";

import styles from '../../../tractionAI.module.scss';
import { copyToClipBoardFromRef } from "modules/tractionAI/utils";
import SnapshotCompanyResponse from "modules/tractionAI/screens/insights/companySnapshot/snapshotCompanyResponse";
import TractionDownload from "../../../../../common/components/tractionDownload";
import LoadingComponent from "modules/primitives/loading/loading.component";
import { BtnType, Button } from "modules/primitives";
import { Icon, smSize } from "../../../../../common/icon";

const CompanySnapshotItemResponse = ({ item, enqueueSnackbar, index }) => {
  const ref = useRef(null);
  const [shouldDownload, setShouldDownload] = useState(false);

  const handleCopy = useCallback(() => {
    if (!ref?.current) return;

    copyToClipBoardFromRef(ref, enqueueSnackbar);
  }, [ref, enqueueSnackbar]);

  const handleDownloadPDF = () => {
    setShouldDownload(true);
  };

  const handleDownloadState = val => {
    setShouldDownload(val);
  };

  return (
    <div className="d-flex flex-column justify-content-end pr-2">
      <div className="d-flex aling-items-end justify-content-end">
        <div className={styles.searchByQuery}>{item.searchByQuery}</div>
      </div>
      <div ref={ref} id={`companySnapshot_${index}`}>
        <SnapshotCompanyResponse
          company={item.data}
          fetched={item.fetched}
          activeDownload={shouldDownload}
        />
      </div>
      <div className="invisible" style={{ width: 0 }}>
        <TractionDownload
          hidePng
          shouldDownloadPdf={shouldDownload}
          handleDownloadState={handleDownloadState}
          timeoutTime={100}
          customId={`companySnapshot_${index}`}
          customName={`Traction-Report-Company-Snapshot-${item.data?.company_name}`}
        />
      </div>
      {(item.fetched || item.doNotAnimate) && (
        <div className="d-flex mt-2 align-items-center">
          <Tooltip
            title="Copy"
            placement="top"
          >
            <div className="cursor-pointer" onClick={handleCopy}>
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6 11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V16C21 18.8284 21 20.2426 20.1213 21.1213C19.2426 22 17.8284 22 15 22H12C9.17157 22 7.75736 22 6.87868 21.1213C6 20.2426 6 18.8284 6 16V11Z"
                  stroke="#1C274C" strokeWidth="1.5" />
                <path
                  d="M6 19C4.34315 19 3 17.6569 3 16V10C3 6.22876 3 4.34315 4.17157 3.17157C5.34315 2 7.22876 2 11 2H15C16.6569 2 18 3.34315 18 5"
                  stroke="#1C274C" strokeWidth="1.5" />
              </svg>
            </div>
          </Tooltip>
          {
            shouldDownload ? (
              <LoadingComponent customText="Preparing pdf..." />
            ) : (
              <Tooltip
                title="Download"
                placement="top"
              >
                <div className="cursor-pointer ml-2" onClick={handleDownloadPDF}>
                  <svg fill="#000000" height="20px" width="20px" version="1.1" id="Layer_1"
                       xmlns="http://www.w3.org/2000/svg"
                       viewBox="0 0 512.001 512.001">
                    <g>
                      <g>
                        <path d="M463.996,126.864L340.192,3.061C338.232,1.101,335.574,0,332.803,0H95.726C67.725,0,44.944,22.782,44.944,50.784v410.434
                    c0,28.001,22.781,50.783,50.783,50.783h320.547c28.001,0,50.783-22.781,50.783-50.783V134.253
                    C467.056,131.482,465.955,128.824,463.996,126.864z M343.254,35.678h0.001l88.126,88.126h-58.242
                    c-7.984,0-15.49-3.109-21.134-8.753c-5.643-5.643-8.752-13.148-8.751-21.131V35.678z M446.159,461.217
                    c-0.001,16.479-13.407,29.885-29.885,29.885H95.726c-16.479,0-29.885-13.406-29.885-29.885V50.784
                    c0.001-16.479,13.407-29.886,29.885-29.886h226.631v73.021c-0.002,13.565,5.28,26.318,14.872,35.909
                    c9.591,9.592,22.345,14.874,35.911,14.874h73.019V461.217z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M375.123,214.719h-41.804v-41.805c0-5.771-4.678-10.449-10.449-10.449H136.877c-5.771,0-10.449,4.678-10.449,10.449
                      v185.992c0,5.771,4.678,10.449,10.449,10.449h41.804v41.805c0,5.771,4.678,10.449,10.449,10.449h185.992
                      c5.771,0,10.449-4.678,10.449-10.449V225.168C385.572,219.397,380.894,214.719,375.123,214.719z M147.326,348.457V183.363H312.42
                      v165.094H147.326z M364.674,400.711H199.58v-31.356h123.29c5.771,0,10.449-4.678,10.449-10.449V235.617h31.355V400.711z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M276.851,123.804h-4.678c-5.771,0-10.449,4.678-10.449,10.449c0.001,5.771,4.679,10.449,10.449,10.449h4.678
                      c5.771,0,10.449-4.678,10.449-10.449C287.3,128.482,282.622,123.804,276.851,123.804z" />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path d="M238.369,123.804H136.877c-5.771,0-10.449,4.678-10.449,10.449s4.678,10.449,10.449,10.449h101.492
                      c5.771,0,10.449-4.678,10.449-10.449C248.818,128.482,244.14,123.804,238.369,123.804z" />
                      </g>
                    </g>
                  </svg>
                </div>
              </Tooltip>
            )
          }
        </div>
      )}
    </div>
  );
};

export default React.memo(CompanySnapshotItemResponse);
